module.exports = __webpack_public_path__ + "static/img/15204192731.f75c420.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15204192731.jpg
// module id = 21vp
// module chunks = 0